import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';

import amplitude from 'amplitude-js';
import { toggleModalWithTimer } from 'apps/auth/actions/appAction';
import { scrollToField } from 'apps/auth/actions/formAction';
import { CommonPage } from 'apps/auth/components/common/Layout/CommonPage/CommonPage';
import Form from 'apps/auth/components/form-multi/Form';
import { ExchangeCalculatorScreen } from 'apps/auth/components/ga/accounts/exchange/ExchangeCalculatorScreen';
import BasePage from 'apps/auth/components/utils/BasePage';
import { EXCHANGE_COMPLETED, NEW_ACCOUNT_ADDED } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { ACCOUNT_CURRENCY, FROM, TO } from 'apps/auth/constants/amplitude/AmplitudeParamName';
import { AMOUNT_TO_CCY } from 'apps/auth/constants/fieldsName';
import { GA_EXCHANGE_FORM_NAME } from 'apps/auth/constants/formName';
import { AUTH_GA_ACCOUNTS, AUTH_GA_POCKET } from 'apps/auth/constants/UrlConstants';

const GAExchangePage = (props) => {
    const freezeAction = useRef(false);
    const [backUrl, setBackUrl] = useState();

    useEffect(() => {
        setBackUrl(`${AUTH_GA_POCKET}${props.pocketId}`);
    }, [props.pocketId]);

    const submitHandler = (fields, json) => {
        if (json) {
            if (json.errors && Object.keys(json.errors).length) {
                const keys = Object.keys(json.errors);
                props.scrollToField(GA_EXCHANGE_FORM_NAME, keys[0]);
            } else if (!json.showServerError) {
                const ccy = Number(fields[AMOUNT_TO_CCY].value);
                const accountTo = props.availableAccountsTo.find((account) => account.pocketCurrency.ncode === ccy);
                if (!accountTo?.id) {
                    amplitude.getInstance().logEvent(NEW_ACCOUNT_ADDED, {
                        [ACCOUNT_CURRENCY]: accountTo.pocketCurrency.code,
                    });
                }
                amplitude.getInstance().logEvent(EXCHANGE_COMPLETED, {
                    [FROM]: props.fromCurrency.code,
                    [TO]: accountTo.pocketCurrency.code,
                });
                props.toggleModalWithTimer(true, props.moneyExchanged, () => {
                    window.location.href = AUTH_GA_ACCOUNTS;
                });
            }
        }
        freezeAction.current = false;
    };

    return (
        <CommonPage backUrl={backUrl} leftCloseIcon hasBottomPanel>
            {props.fields && (
                <Form
                    formName={GA_EXCHANGE_FORM_NAME}
                    action={`/auth/ga/pocket/${props.pocketId}/exchange/payment`}
                    getCanonicalPath={true}
                    onSubmitHandler={submitHandler}
                >
                    <ExchangeCalculatorScreen formName={GA_EXCHANGE_FORM_NAME} freezeAction={freezeAction} />
                </Form>
            )}
        </CommonPage>
    );
};
const mapStateToProps = (state) => {
    return {
        pocketId: state.extra.pocket?.id,
        fields: state.form[GA_EXCHANGE_FORM_NAME]?.fields,
        fromCurrency: state.extra.pocket?.pocketCurrency,
        availableAccountsTo: state.extra.availableAccountsTo,
        moneyExchanged: state.messages.pageMessages.moneyExchanged,
    };
};

export default connect(mapStateToProps, { scrollToField, toggleModalWithTimer })(BasePage(GAExchangePage));
